const THREE_DS_STATUSES = {
    AUTHORISED: 'authorised',
    CANCELLED: 'cancelled',
    UNEXPECTED: 'unexpected',
    IN_PROGRESS: '3ds_in_progress',
};
const PENDING_STATUSES = [THREE_DS_STATUSES.IN_PROGRESS];
const FINISH_STATUSES = [
    THREE_DS_STATUSES.AUTHORISED,
    THREE_DS_STATUSES.CANCELLED,
    THREE_DS_STATUSES.UNEXPECTED,
];

export { FINISH_STATUSES, PENDING_STATUSES, THREE_DS_STATUSES };
//# sourceMappingURL=threeDSStatuses.js.map
